import { IApiClient, IOfferService, IOfferServiceOptions, compressAndBase62Encode } from '../common';

const dummyHost = "http://localhost:3000/";

class OfferService implements IOfferService {

    _baseRoute = "offer";

    apiClient: IApiClient;
    callerEnvironment: string;
    getLanguage: any;

    constructor(options: IOfferServiceOptions) {

        this.resolveOptions(options);
    }

    resolveOptions(options: IOfferServiceOptions) {
        this.apiClient = options.apiClient;
        this.callerEnvironment = options.callerEnvironment;
        if (typeof options.getLanguage === "function") {
            this.getLanguage = options.getLanguage;
        }
    }

    private createRelativeUrl(urlRoute: string, filter: string) {

        const url = new URL(dummyHost + urlRoute);
        url.searchParams.set('filter', filter);
        url.searchParams.set('Caller-Environment', this.callerEnvironment);

        return url.toString().slice(dummyHost.length);
    }

    async getOffer(offerFilter: any) {
        const urlRoute = this._baseRoute;
        const filter = compressAndBase62Encode(this.injectAdditionalFieldsToOfferFilter(offerFilter));

        const relativeUrl = this.createRelativeUrl(urlRoute, filter);

        const response = await this.apiClient.get(relativeUrl);

        return response;
    }

    async getOfferData(offerFilter: any, abortController?: any) {
        const urlRoute = `${this._baseRoute}/data`;
        const filter = compressAndBase62Encode(this.injectAdditionalFieldsToOfferFilter(offerFilter));

        const relativeUrl = this.createRelativeUrl(urlRoute, filter);


        const response = await this.apiClient.get(relativeUrl, abortController);

        return response;
    }

    async getSportsMenu(offerFilter: any, abortController?: any) {
        const urlRoute = `${this._baseRoute}/sport-menu`;
        const filter = compressAndBase62Encode(this.injectAdditionalFieldsToOfferFilter(offerFilter));

        const relativeUrl = this.createRelativeUrl(urlRoute, filter);

        const response = await this.apiClient.get(relativeUrl, abortController);

        return response;
    }

    private injectAdditionalFieldsToOfferFilter(offerFilter: any) {
        if(this.getLanguage != null){
            offerFilter.language = this.getLanguage();
        }

        return offerFilter;
    }
}


export default OfferService;